import { useEffect } from "react";

import { shallow } from "zustand/shallow";

import usePulseStore from "@app/analytics/Pulse/stores/pulse";
import type { PulseMetadata } from "@app/analytics/Pulse/types";
import { getDropdownOptionsById } from "@app/analytics/Pulse/utils";

import usePulseByIdQuery from "./usePulseByIdQuery";
import usePulseMetadataQuery from "./usePulseMetadataQuery";

const EMPTY_METADATA_RESULTS: PulseMetadata[] = [];
const EMPTY_MAP = new Map<string, PulseMetadata>();

const useForYourWorkspace = () => {
  const { setDropdownOptions, selectedRange } = usePulseStore(
    (state) => ({
      setDropdownOptions: state.setDropdownOptions,
      selectedRange: state.forYourWorkspace.selectedRange,
    }),
    shallow
  );

  const pulseMetadataQuery = usePulseMetadataQuery();

  const metadata =
    pulseMetadataQuery.data?.workspace.parsedResults ?? EMPTY_METADATA_RESULTS;
  const metadataResultsById =
    pulseMetadataQuery.data?.workspace.resultsById ?? EMPTY_MAP;

  const selectedWorkspacePulseId = metadataResultsById.get(
    selectedRange.value
  )?.id;

  const workspaceQuery = usePulseByIdQuery({ id: selectedWorkspacePulseId });

  useEffect(() => {
    if (pulseMetadataQuery.isLoading) return;
    const dropdownOptions = getDropdownOptionsById(metadata);

    setDropdownOptions("forYourWorkspace", dropdownOptions);
  }, [pulseMetadataQuery.isLoading, metadata]);

  const hasPermissionError =
    !workspaceQuery.isLoading &&
    workspaceQuery.isError &&
    workspaceQuery.error.message.includes("403");

  return {
    isLoading: workspaceQuery.isLoading || pulseMetadataQuery.isLoading,
    workspaceQuery,
    hasPermissionError,
  };
};

export default useForYourWorkspace;
